import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('add_as_many_steps_as_you_need'),
    subtitle: defineMessage('for_example_if_a_bill_n_ceo_you_will_need_steps'),
    addStep: defineMessage('add_step'),
    step: defineMessage('step_number'),
    placeholder: defineMessage('enter_the_step_name'),
};
